/* ============================================================
   assets/mc-gift.js — konfigurator poklona (product.konfigurator)
   sections/mc-gift-gallery.liquid  (kartica u kutiji + izbliza)
   sections/mc-gift-builder.liquid  (naslov, cijena, koraci 1–3)
   sections/bh-cod-order-form.liquid (korak 4 — forma, preoblikovana)
   sections/mc-gift-details.liquid  (paket, pitanja, donja traka)

   Jedan izvor stanja: izbor kupca. Iz njega se crta svaka kartica na
   stranici (mockup, izbliza, sličice) i pune skrivena polja koja forma
   za narudžbu šalje na narudžbu (mc:dedication).

   Raspored kartice je isti kao šablon za štampu (Order Printer, kartica
   v2): naslov gore, dug tekst lijevo/desno od privjeska i ispod, potpis
   na dnu; font je najveći s kojim ništa ne ulazi u zonu srca. Zato što
   kupac vidi = što se štampa.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-mc-gift]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };

  var data = {};
  try { data = JSON.parse($('[data-mc-gift-data]', root).textContent); } catch (e) { data = { messages: [] }; }

  var GIVERS = (data.givers || []).map(function (s) { return String(s).trim(); });
  var MESSAGES = data.messages || [];
  var VISIBLE = data.visible || 3;
  var SIGNS = {};                                   // SIGNS[r][g] = [...]
  (data.signs || []).forEach(function (line) {
    var p = String(line).trim().split('|');
    if (p.length < 3) return;
    var r = p[0].trim(), g = p[1].trim(), t = p.slice(2).join('|').trim();
    if (!t) return;
    (SIGNS[r] = SIGNS[r] || {});
    (SIGNS[r][g] = SIGNS[r][g] || []).push(t);
  });
  var FALLBACK_TITLE = { supruga: 'Ljubavi', mama: { ja: 'Mojoj mami', mi: 'Našoj mami' }, kcerka: { ja: 'Mojoj kćeri', mi: 'Našoj kćeri' }, drugo: 'Za tebe',
    sestra: 'Mojoj sestri', drugarica: 'Mojoj drugarici', kuma: 'Mojoj kumi', snaha: { ja: 'Mojoj snahi', mi: 'Našoj snahi' }, unuka: { ja: 'Mojoj unuci', mi: 'Našoj unuci' },
    svekrva: { ja: 'Mojoj svekrvi', mi: 'Našoj svekrvi' }, baka: { ja: 'Mojoj baki', mi: 'Našoj baki' } };
  var EYEBROW = { supruga: 'Poklon za suprugu ili djevojku', mama: 'Poklon za mamu', kcerka: 'Poklon za kćerku', drugo: 'Poklon s tvojom porukom',
    sestra: 'Poklon za sestru', drugarica: 'Poklon za drugaricu', kuma: 'Poklon za kumu', snaha: 'Poklon za snahu', unuka: 'Poklon za unuku', svekrva: 'Poklon za svekrvu', baka: 'Poklon za baku' };
  // primaoci iz drugog reda („Nekom drugom“ → Sestri, Drugarici, …)
  var SUB = ['svekrva', 'baka', 'sestra', 'drugarica', 'kuma', 'snaha', 'unuka', 'drugo'];

  var st = { r: null, g: 'ja', m: null, more: false, open: false, occ: '' };
  var dirty = { head: false, sign: false };

  var ded = root;   // [data-mc-dedication] je sam korijen (vidi mc-gift-builder.liquid)
  var propText = $('[data-mc-prop-text]', ded), propSign = $('[data-mc-prop-sign]', ded);
  var head = $('[data-mc-head]', root), sign = $('[data-mc-sign]', root);
  var own = $('[data-mc-own-text]', root), asis = $('[data-mc-asis]', root);

  function msgsFor(r) { return MESSAGES.filter(function (m) { return m.r === r && (m.ja.text || m.mi.text); }); }
  function hasGiver(r) { return GIVERS.indexOf(r) !== -1; }
  function form(m) { return (st.g === 'mi' && m.mi && m.mi.text) ? m.mi : m.ja; }
  function signsFor() { return (SIGNS[st.r] && SIGNS[st.r][st.g]) || []; }

  function current() {
    if (!st.r || !st.m) return null;
    if (st.m === 'OWN') return { id: 'VLASTITA', title: '', text: own.value.trim(), sign: '' };
    var m = MESSAGES.filter(function (x) { return x.id === st.m && x.r === st.r; })[0];
    if (!m) return null;
    var f = form(m);
    return { id: m.id + (hasGiver(st.r) ? '-' + st.g.toUpperCase() : ''), title: f.title, text: f.text, sign: f.sign };
  }

  function fallbackTitle() {
    var t = FALLBACK_TITLE[st.r];
    return t && typeof t === 'object' ? t[st.g] : (t || 'Za tebe');
  }

  /* ---------- kartica: raspored i veličina teksta ---------- */
  /* Dug tekst se dijeli na tri dijela: lijevo i desno od privjeska (~28%
     teksta svaki) i ostatak ispod. Rez se traži blizu cilja, a prednost
     imaju kraj rečenice, pa zarez — nikad po broju rečenica, jer poruka s
     jednom kratkom i jednom vrlo dugom rečenicom tada daje jednu liniju
     lijevo i stupac desno koji preraste naslov. Kratke poruke (do LONG
     znakova) ostaju jedan blok ispod srca. */
  // donja ivica privjeska na kartici (udio visine); N005 srce 0,63, niži privjesci više
  var LONG = 160, HEART_BOTTOM = parseFloat(root.dataset.pendBottom) || 0.63, FS_MAX = 4.4, FS_MIN = 3.0;
  // privjesak koji visi niže ostavlja manje mjesta ispod: više teksta ide u stupce uz njega
  var SPLIT = HEART_BOTTOM > 0.64 ? 0.31 : 0.28;

  function splitText(text) {
    if (text.length <= LONG) return null;
    var words = text.split(/\s+/);
    var total = text.length;
    function cut(from, target) {
      var len = 0, best = -1, bestScore = Infinity;
      for (var i = from; i < words.length - 2; i++) {
        len += words[i].length + (i > from ? 1 : 0);
        var w = words[i], bonus = /[.!?…]["“”]?$/.test(w) ? 0.14 : /[,;:]$/.test(w) ? 0.07 : 0;
        var score = Math.abs(len - target) / total - bonus;
        if (score < bestScore) { bestScore = score; best = i; }
        if (len > target * 1.5) break;
      }
      return best + 1;
    }
    var a = cut(0, total * SPLIT);
    var b = cut(a, total * SPLIT);
    if (a <= 0 || b <= a || b >= words.length) return null;
    return [words.slice(0, a).join(' '), words.slice(a, b).join(' '), words.slice(b).join(' ')];
  }

  // Najveći font s kojim tekst ne ulazi u zonu srca i ne dodiruje naslov.
  function fitCard(c) {
    var t = $('.mcg-card__title', c), body = $('.mcg-card__body', c), foot = $('.mcg-card__foot', c);
    var split = !!$('.mcg-card__mid', c);
    for (var fs = FS_MAX; fs >= FS_MIN; fs = Math.round((fs - 0.1) * 10) / 10) {
      c.style.setProperty('--fs', fs);
      var H = c.clientHeight, gap = 0.015 * H;
      var titleBottom = t.offsetTop + t.offsetHeight, footTop = foot.offsetTop;
      var bodyTop = body.offsetTop - body.offsetHeight / 2, bodyBottom = body.offsetTop + body.offsetHeight / 2;
      if (footTop >= HEART_BOTTOM * H && (!split || (bodyTop >= titleBottom + gap && bodyBottom <= footTop - gap))) return fs;
    }
    return FS_MIN;
  }

  function el(cls, txt) { var d = document.createElement('div'); d.className = cls; if (txt != null) d.textContent = txt; return d; }

  function drawCard(c, m) {
    var text = m && m.text ? m.text : '';
    var empty = !text;
    var title = head.value.trim() || (m && m.title) || (st.r ? fallbackTitle() : 'Za nekog posebnog');
    c.innerHTML = '';
    c.classList.toggle('is-empty', empty);
    c.appendChild(el('mcg-card__title', title));
    var shown = empty ? (st.r ? 'Izaberi poruku ili napiši svoju…' : 'Izaberi kome poklanjaš i poruku, pa ovdje vidiš svoju karticu.') : text;
    var parts = empty ? null : splitText(shown);
    var body = el('mcg-card__body'), foot = el('mcg-card__foot');
    if (parts) {
      var mid = el('mcg-card__mid');
      mid.appendChild(el('mcg-card__text', parts[0])); mid.appendChild(el('mcg-card__pend'));
      mid.appendChild(el('mcg-card__text', parts[1]));
      body.appendChild(mid); foot.appendChild(el('mcg-card__text', parts[2]));
    } else {
      body.appendChild(el('mcg-card__pend')); foot.appendChild(el('mcg-card__text', shown));
    }
    var s = sign.value.trim();
    if (st.occ || s) {
      var sg = el('mcg-card__sign');
      // s potpisom: Sretan rođendan, + potpis; bez potpisa uzvičnik umjesto visećeg zareza
      if (st.occ) sg.appendChild(el('mcg-card__bd', st.occ + (s ? ',' : '!')));
      if (s) sg.appendChild(document.createTextNode(s));
      foot.appendChild(sg);
    }
    c.appendChild(body); c.appendChild(foot);
    c.appendChild(el('mcg-card__brand', 'Moments & Co'));
  }

  function renderCards() {
    var m = current();
    var cards = $$('[data-mcg-card]');
    cards.forEach(function (c) { drawCard(c, m); });
    // Sve kartice su iste veličine (1000 px) i istog sadržaja: izmjeri vidljivu, primijeni na sve.
    var vis = cards.filter(function (c) { return c.clientHeight > 0 && c.offsetParent !== null; })[0];
    if (vis) {
      var fs = fitCard(vis);
      cards.forEach(function (c) { c.style.setProperty('--fs', fs); });
    }
  }

  /* ---------- mockup u kutiji i kartica izbliza ---------- */
  function quadMatrix(w, h, q) {
    // projektivno preslikavanje kvadrata w×h na četverougao (Heckbert)
    var x0 = q[0], y0 = q[1], x1 = q[2], y1 = q[3], x2 = q[4], y2 = q[5], x3 = q[6], y3 = q[7];
    var dx1 = x1 - x2, dx2 = x3 - x2, dx3 = x0 - x1 + x2 - x3, dy1 = y1 - y2, dy2 = y3 - y2, dy3 = y0 - y1 + y2 - y3;
    var den = dx1 * dy2 - dx2 * dy1;
    var g = (dx3 * dy2 - dx2 * dy3) / den, h2 = (dx1 * dy3 - dx3 * dy1) / den;
    var a = x1 - x0 + g * x1, b = x3 - x0 + h2 * x3, d = y1 - y0 + g * y1, e = y3 - y0 + h2 * y3;
    return 'matrix3d(' + [a / w, d / w, 0, g / w, b / h, e / h, 0, h2 / h, 0, 0, 1, 0, x0, y0, 0, 1].join(',') + ')';
  }

  function scaleTo(box, stage, size) {
    var fit = function () { if (box.clientWidth) stage.style.transform = 'scale(' + (box.clientWidth / size) + ')'; };
    if (window.ResizeObserver) new ResizeObserver(fit).observe(box); else window.addEventListener('resize', fit);
    fit();
  }

  function buildMock(m) {
    var size = parseInt(m.dataset.size, 10) || 1200;
    var q = (m.dataset.quad || '').split(',').map(Number);
    if (q.length !== 8 || q.some(isNaN)) return;
    var stage = el('mc-mock__stage');
    stage.style.width = stage.style.height = size + 'px';
    var img = function (src) { var i = document.createElement('img'); i.src = src; i.alt = ''; i.width = size; i.height = size; i.decoding = 'async'; return i; };
    var design = el('mc-mock__design');
    design.style.width = design.style.height = size + 'px';
    design.style.webkitMaskImage = design.style.maskImage = 'url(' + m.dataset.mask + ')';
    design.style.webkitMaskSize = design.style.maskSize = size + 'px ' + size + 'px';
    var wrap = el('mc-mock__card');
    wrap.style.transform = quadMatrix(1000, 1000, q);
    var card = el('mcg-card mcg-card--box');
    card.setAttribute('data-mcg-card', '');
    wrap.appendChild(card); design.appendChild(wrap);
    stage.appendChild(img(m.dataset.base));
    stage.appendChild(design);
    stage.appendChild(img(m.dataset.light));
    stage.appendChild(img(m.dataset.neck));
    m.appendChild(stage);
    scaleTo(m, stage, size);
  }
  $$('[data-mc-mock]').forEach(buildMock);

  function buildFlat(f) {
    var stage = el('mc-flat__stage');
    var card = el('mcg-card mcg-card--flat');
    card.setAttribute('data-mcg-card', '');
    stage.appendChild(card); f.appendChild(stage);
    scaleTo(f, stage, 1000);
  }
  $$('[data-mc-flat]').forEach(buildFlat);

  /* ---------- galerija ---------- */
  function go(i) {
    $$('[data-mc-slide]').forEach(function (s) { s.classList.toggle('is-on', +s.dataset.mcSlide === i); });
    $$('.mcp-gal__thumb').forEach(function (t) { t.classList.toggle('is-on', +t.dataset.mcGo === i); });
    renderCards();
  }
  $$('[data-mc-go]').forEach(function (b) { b.addEventListener('click', function () { go(+b.dataset.mcGo); }); });
  /* „Uvećaj karticu": kartica preko ekrana, s dugmetom „Nazad na narudžbu".
     Ranije je vodila na galeriju na vrhu, pa je kupac morao ponovo skrolati
     do adrese. Prozor ide u <body> (izvan okvira koji reže sadržaj), a
     dugme „nazad" na telefonu ga zatvara umjesto da napusti stranicu. */
  var zoomBox = $('[data-mc-zoom-box]');
  if (zoomBox) {
    document.body.appendChild(zoomBox);
    var lastFocus = null;
    var hideZoom = function () {
      if (zoomBox.hidden) return;
      zoomBox.hidden = true;
      document.documentElement.classList.remove('mcp-noscroll');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    };
    var closeZoom = function () {
      if (zoomBox.hidden) return;
      if (history.state && history.state.mcZoom) history.back(); else hideZoom();
    };
    $$('[data-mc-zoom]').forEach(function (b) {
      b.addEventListener('click', function () {
        lastFocus = b;
        zoomBox.hidden = false;
        document.documentElement.classList.add('mcp-noscroll');
        if (window.history && history.pushState) history.pushState({ mcZoom: 1 }, '');
        renderCards();
        $('[data-mc-zoom-close]', zoomBox).focus({ preventScroll: true });
      });
    });
    $('[data-mc-zoom-close]', zoomBox).addEventListener('click', closeZoom);
    zoomBox.addEventListener('click', function (e) { if (e.target === zoomBox) closeZoom(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeZoom(); });
    window.addEventListener('popstate', hideZoom);
  }

  // Kopiraj šifru: za kupce koji šifru šalju porukom (Viber, Instagram)
  $$('[data-mc-copy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var code = b.dataset.mcCopy, label = b.textContent;
      var done = function () { b.textContent = 'Kopirano ✓'; b.classList.add('is-done'); setTimeout(function () { b.textContent = label; b.classList.remove('is-done'); }, 2000); };
      var fallback = function () {
        var t = document.createElement('textarea'); t.value = code; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
        document.body.appendChild(t); t.select(); try { document.execCommand('copy'); done(); } catch (e) {} document.body.removeChild(t);
      };
      if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(done, fallback); else fallback();
    });
  });

  /* ---------- izbor ---------- */
  function renderMsgs() {
    var box = $('[data-mc-msgs]', root);
    box.innerHTML = '';
    var all = msgsFor(st.r);
    var list = st.more ? all : all.slice(0, VISIBLE);
    // izabrana poruka iz „još poruka" ostaje vidljiva i kad je lista skraćena
    if (!st.more && st.m && st.m !== 'OWN' && list.every(function (m) { return m.id !== st.m; })) {
      list = list.concat(all.filter(function (m) { return m.id === st.m; }));
    }
    list.forEach(function (m) {
      var f = form(m), on = st.m === m.id;
      var b = document.createElement('div');
      b.className = 'mcp-msg' + (on && st.open ? ' is-open' : '');
      b.setAttribute('role', 'radio'); b.tabIndex = 0;
      b.dataset.mcM = m.id;
      b.setAttribute('aria-checked', String(on));
      var top = el('mcp-msg__top');
      var t = el('mcp-msg__t'); t.appendChild(el('mcp-msg__dot')); t.appendChild(document.createTextNode(f.title));
      top.appendChild(t);
      if (m.tag) top.appendChild(el('mcp-msg__tag', m.tag));
      b.appendChild(top);
      b.appendChild(el('mcp-msg__x', f.text));
      if (on) {
        var rd = document.createElement('button');
        rd.type = 'button'; rd.className = 'mcp-link mcp-msg__read';
        rd.textContent = st.open ? 'Skrati poruku' : 'Pročitaj cijelu poruku';
        rd.addEventListener('click', function (ev) { ev.stopPropagation(); st.open = !st.open; renderMsgs(); });
        b.appendChild(rd);
      }
      var pick = function () { if (st.m !== m.id) { st.open = false; pickMsg(m.id); } };
      b.addEventListener('click', pick);
      b.addEventListener('keydown', function (ev) { if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); pick(); } });
      box.appendChild(b);
    });
    var more = $('[data-mc-more]', root);
    more.hidden = st.more || all.length <= VISIBLE;
    $('[data-mc-own-btn]', root).setAttribute('aria-pressed', String(st.m === 'OWN'));
    $('[data-mc-own]', root).hidden = st.m !== 'OWN';
    renderSignChips(); renderOcc();
  }

  function renderSignChips() {
    var box = $('[data-mc-schips]', root);
    box.innerHTML = '';
    signsFor().forEach(function (s) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'mcp-schip';
      // na dugmetu kratko („mama i tata"), u potpisu cijelo („Vole te mama i tata")
      var shortTxt = s.replace(/^(Vole|Voli) te\s+/, '');
      b.textContent = /\bi (brat|sestra)$/.test(s) ? shortTxt + '…' : shortTxt;
      b.setAttribute('aria-pressed', String(sign.value.trim() === s));
      b.addEventListener('click', function () {
        dirty.sign = true;
        // „…i brat" / „…i sestra": kupac dopiše ime
        sign.value = /\bi (brat|sestra)$/.test(s) ? s + ' ' : s;
        if (/\bi (brat|sestra)$/.test(s)) sign.focus();
        renderSignChips(); update();
      });
      box.appendChild(b);
    });
  }

  // Čestitka iznad potpisa: jedna ili nijedna. Godišnjica samo za suprugu/djevojku.
  function renderOcc() {
    $$('[data-mc-occ]', root).forEach(function (b) {
      var forR = b.dataset.mcOccFor;
      b.hidden = !!forR && forR !== st.r;
      if (b.hidden && st.occ === b.dataset.mcOcc) st.occ = '';
      var on = st.occ === b.dataset.mcOcc;
      b.setAttribute('aria-pressed', String(on));
      // Riječima, ne prekidačem: „+ Dodaj …" / „✓ … · ukloni" — jasno i onome
      // ko nikad nije koristio iOS prekidač.
      b.textContent = on ? '✓ ' + b.dataset.mcOcc + ' · ukloni' : '+ Dodaj „' + b.dataset.mcOcc + '“';
    });
  }
  $$('[data-mc-occ]', root).forEach(function (b) {
    b.addEventListener('click', function () {
      st.occ = st.occ === b.dataset.mcOcc ? '' : b.dataset.mcOcc;
      renderOcc(); update();
    });
  });

  // Naslov i potpis prate poruku dok ih kupac sam ne promijeni.
  function applyDefaults() {
    var m = current();
    if (!dirty.head) head.value = m && st.m !== 'OWN' ? m.title : '';
    if (!dirty.sign) sign.value = (m && m.sign) || (st.g === 'mi' ? (signsFor()[0] || '') : '');
    head.placeholder = fallbackTitle();
    sign.placeholder = signsFor()[0] ? 'npr. ' + signsFor()[0] : 'npr. Tvoja Amra';
  }

  function setGiver(g) {
    st.g = g;
    $$('[data-mc-g]', root).forEach(function (b) { b.setAttribute('aria-checked', String(b.dataset.mcG === g)); });
    dirty.head = dirty.sign = false;   // "Mojoj" ↔ "Našoj": vrati na zadano
  }

  function unlock() {
    $$('[data-mc-g-step]', root).forEach(function (s) { s.classList.remove('is-locked'); });
  }

  function pickRecipient(r, quiet) {
    st.r = r; st.more = false; st.open = false;
    var list = msgsFor(r);
    st.m = list.length ? list[0].id : 'OWN';
    var inSub = SUB.indexOf(r) !== -1;
    $$('[data-mc-r]', root).forEach(function (b) {
      b.setAttribute('aria-checked', String(b.dataset.mcR === r || (inSub && b.hasAttribute('data-mc-main-drugo'))));
    });
    var subRow = $('[data-mc-sub]', root);
    if (subRow) subRow.hidden = !inSub;
    $('[data-mc-giver]', root).hidden = !hasGiver(r);
    setGiver(hasGiver(r) && r === 'kcerka' ? 'mi' : 'ja');
    var eb = $('[data-mc-eyebrow]');
    if (eb) eb.textContent = EYEBROW[r] || eb.dataset.default;
    applyDefaults(); unlock(); renderMsgs(); update(); go(0);
    if (!quiet && window.innerWidth < 990) {
      var t = r === 'drugo' && subRow ? subRow : hasGiver(r) ? $('[data-mc-giver]', root) : $('[data-mc-g-step="2"]', root);
      t.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function pickMsg(id) {
    st.m = id;
    if (!dirty.head) applyDefaults();
    renderMsgs();
    if (id === 'OWN') own.focus();
    update(); go(0);
  }

  $$('[data-mc-r]', root).forEach(function (b) { b.addEventListener('click', function () { pickRecipient(b.dataset.mcR); }); });
  $$('[data-mc-g]', root).forEach(function (b) {
    b.addEventListener('click', function () { setGiver(b.dataset.mcG); applyDefaults(); renderMsgs(); update(); go(0); });
  });
  $('[data-mc-own-btn]', root).addEventListener('click', function () { if (st.r) pickMsg('OWN'); });
  $('[data-mc-more]', root).addEventListener('click', function () { st.more = true; renderMsgs(); });
  own.addEventListener('input', function () { $('[data-mc-own-count]', root).textContent = own.value.length; update(); });
  head.addEventListener('input', function () { dirty.head = true; update(); });
  sign.addEventListener('input', function () { dirty.sign = true; renderSignChips(); update(); });
  asis.addEventListener('change', update);

  /* ---------- korak 4: forma za pouzeće kao nastavak kartice ----------
     Forma je sections/bh-cod-order-form.liquid — ista kao na svakom PDP-u,
     sa svom logikom (worker, provjera duplih, upsell). Ovdje se samo
     preslaže da izgleda kao korak 4 iz dizajna: naslov s brojem, količina
     uz grad, obračun iznad dugmeta. Elementi se premještaju, ne kopiraju,
     pa njihovi slušači i dalje rade. */
  var cod = document.querySelector('[data-bh-cod]');
  if (cod) {
    document.documentElement.classList.add('mcp-has-cod');
    var fields = cod.querySelector('.bh-fields');
    if (fields) {
      // naslov „Unesite podatke" je zadnji .bh-form__h prije polja (zna biti
      // umotan u div), a ne onaj u redu za količinu
      var h = Array.prototype.filter.call(cod.querySelectorAll('.bh-form__h'), function (x) {
        return !x.closest('.mc-qtyrow') && (x.compareDocumentPosition(fields) & Node.DOCUMENT_POSITION_FOLLOWING);
      }).pop();
      if (h) {
        h.classList.add('mcp-step__h', 'mcp-step__h--4');
        h.innerHTML = '';
        h.appendChild(el('mcp-n', '4'));
        h.appendChild(document.createTextNode(data.step4 || 'Gdje šaljemo?'));
        var sub = el('mcp-ship-note', data.step4sub || '');
        h.parentNode.insertBefore(sub, h.nextSibling);
      }
      var city = cod.querySelector('#bh-city');
      var qty = cod.querySelector('.mc-qtyrow');
      var cityField = city && city.closest('.bh-field');
      if (cityField && qty) {
        var pair = el('mcp-pair');
        cityField.parentNode.insertBefore(pair, cityField);
        pair.appendChild(cityField); pair.appendChild(qty);
      }
    }
    /* Konfigurator se obraća sa „ti“, pa i greške forme. Forma je ista za
       cijeli sajt (gdje se kaže „vi“), zato se tekstovi mijenjaju samo ovdje. */
    var TI = {
      errNoMessage: 'Narudžba nije poslana. Izaberi poruku za karticu ili napiši svoju.',
      errFormLabel: 'Narudžba nije poslana. Provjeri:',
      errSendLabel: 'Narudžba nije poslana. Provjeri internet i pokušaj ponovo, ili nas nazovi.',
      errRateLabel: 'Narudžba je već poslana maloprije. Sačekaj malo ili nas nazovi.',
      errPhoneLabel: 'Upiši ispravan broj (npr. 062123456)',
      dupeLabel: 'Ovaj proizvod je već naručen prije {min} min. Druga narudžba nije napravljena.',
      dupeNowLabel: 'Ovaj proizvod je upravo naručen. Druga narudžba nije napravljena.'
    };
    Object.keys(TI).forEach(function (k) { cod.dataset[k] = TI[k]; });
    var ERR = { name: 'Upiši ime i prezime', phone: 'Upiši ispravan broj (npr. 062123456)', address: 'Upiši ulicu i broj', city: 'Upiši grad ili mjesto', email: 'Provjeri email adresu' };
    Object.keys(ERR).forEach(function (k) { var e = cod.querySelector('#bh-err-' + k); if (e) e.textContent = ERR[k]; });

    /* „Naruči“ bez poruke: forma skrola ovamo, ali grešku ispiše dolje uz
       obračun (van ekrana) i ostavi je i kad kupac izabere poruku. Ovdje se
       ista poruka pokaže gore, uz korake, i obje nestanu čim ima teksta. */
    var formErrEl = cod.querySelector('[data-bh-formerr]');
    var need = el('mcp-need');
    need.setAttribute('role', 'alert'); need.hidden = true;
    var headEl = $('.mcp-cfg__head', root);
    if (headEl) headEl.parentNode.insertBefore(need, headEl.nextSibling);
    var syncNeed = function () {
      var m = current();
      var noMsg = !!formErrEl && !formErrEl.hidden && formErrEl.textContent === TI.errNoMessage;
      if (noMsg && m && m.text) { formErrEl.hidden = true; formErrEl.textContent = ''; noMsg = false; }
      var wasHidden = need.hidden;
      need.hidden = !noMsg;
      // poslije skrola forme: dovedi obavijest i korak 1 na vrh ekrana
      if (noMsg && wasHidden) setTimeout(function () { need.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 0);
      if (noMsg) need.textContent = st.r ? 'Izaberi poruku za karticu ili napiši svoju (korak 2).' : 'Prvo izaberi kome poklanjaš (korak 1), pa poruku.';
    };
    if (formErrEl && window.MutationObserver) new MutationObserver(syncNeed).observe(formErrEl, { attributes: true, childList: true, characterData: true, subtree: true });
    root.addEventListener('mc:dedication', syncNeed);

    var cta = cod.querySelector('.bh-btn--order-lg');
    var bd = cod.querySelector('.bh-breakdown');
    if (cta && bd) cta.parentNode.insertBefore(bd, cta);
    // Dugme kao u dizajnu: „Naruči pouzećem — 94,90 KM" u jednom redu,
    // ispod sitnije kad se plaća. Prevod je VELIKIM SLOVIMA; bh-cod-form.js
    // gradi tekst iz data-base + iznos, pa se mijenja i data-base.
    var ctaMain = cta && cta.querySelector('[data-bh-cta]');
    if (ctaMain && !cta.disabled) {
      var parts = ctaMain.textContent.split('—');
      ctaMain.dataset.base = 'Naruči pouzećem';
      if (parts[1]) ctaMain.textContent = 'Naruči pouzećem — ' + parts[1].trim();
      var ctaSub = cta.querySelector('.bh-btn__sub');
      if (ctaSub) ctaSub.textContent = 'Plaćaš kuriru kad paket stigne';
    }
  }

  /* ---------- napredak i donja traka ---------- */
  function shipReady() {
    if (!cod) return false;
    return ['#bh-name', '#bh-phone', '#bh-address', '#bh-city'].every(function (s) {
      var i = cod.querySelector(s); return i && i.value.trim().length > 1;
    });
  }
  function paintBars() {
    var m = current();
    var done = [!!st.r, !!(m && m.text), !!(m && m.text && (sign.value.trim() || st.occ)), shipReady()];
    $$('[data-mc-bar]', root).forEach(function (b, i) { b.classList.toggle('is-done', done[i]); });
  }
  if (cod) cod.addEventListener('input', paintBars);

  var bar = $('[data-mc-bar-sticky]');
  if (bar) {
    bar.hidden = false;
    $('[data-mc-bar-go]', bar).addEventListener('click', function () {
      var m = current();
      var target = !st.r ? $('[data-mc-g-step="1"]', root)
        : !(m && m.text) ? $('[data-mc-g-step="2"]', root)
        : (cod && cod.querySelector('.bh-fields')) || $('[data-mc-g-step="3"]', root);
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (st.r && m && m.text && cod) {
        var first = cod.querySelector('#bh-name');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 450);
      }
    });
    // traka se sakriva dok je dugme za narudžbu na ekranu
    var ctaBtn = cod && cod.querySelector('.bh-btn--order-lg');
    if (ctaBtn && window.IntersectionObserver) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { bar.classList.toggle('is-away', e.isIntersecting); });
      }).observe(ctaBtn);
    }
  }

  /* ---------- prema formi za narudžbu ---------- */
  function update() {
    renderCards();
    var m = current();
    var text = m ? m.text : '';
    var title = head.value.trim() || (m && m.title) || (st.r ? fallbackTitle() : '');
    var extra = {
      'Naslov': text ? title : '',
      'Povod': st.occ,
      '_Poruka ID': m ? m.id : '',
      '_Pravopis': st.m === 'OWN' && asis.checked ? 'Tačno ovako' : 'Ispraviti',
      '_Primalac': st.r || ''
    };
    propText.value = text;
    propSign.value = sign.value.trim();
    $$('[data-mc-x]', ded).forEach(function (i) { i.value = extra[i.dataset.mcX] || ''; });
    ded.dataset.extra = JSON.stringify(extra);
    syncUrl();
    paintBars();
    root.dispatchEvent(new CustomEvent('mc:dedication', {
      bubbles: true,
      detail: {
        card: true,
        // bh-cod-form.js ne šalje narudžbu dok nema teksta za štampu
        ready: !!text,
        text: text,
        sign: propSign.value,
        feeCents: 0,
        cardVariantId: '',
        extra: extra
      }
    }));
  }

  /* ---------- izbor u URL-u ----------
     ?za=kcerka&od=mi&poruka=k-14 — link vodi tačno na tu karticu (oglasi,
     slanje linka), a osvježavanje ili „nazad" ne briše izbor. Samo izbor,
     nikad tekst koji je kupac upisao: vlastita poruka je samo poruka=svoja.
     Ostali parametri (utm, fbclid, variant…) ostaju netaknuti. */
  function syncUrl() {
    if (!window.history || !history.replaceState) return;
    var q = new URLSearchParams(location.search);
    q.delete('za'); q.delete('od'); q.delete('poruka');
    if (st.r) {
      q.set('za', st.r);
      if (hasGiver(st.r)) q.set('od', st.g);
      if (st.m) q.set('poruka', st.m === 'OWN' ? 'svoja' : String(st.m).toLowerCase());
    }
    var s = q.toString();
    var url = location.pathname + (s ? '?' + s : '') + location.hash;
    if (url !== location.pathname + location.search + location.hash) history.replaceState(history.state, '', url);
  }

  var qs = new URLSearchParams(location.search);
  var za = qs.get('za');
  if (za && $('[data-mc-r="' + za + '"]', root)) {
    pickRecipient(za, true);
    var od = qs.get('od');
    if (hasGiver(za) && (od === 'ja' || od === 'mi')) { setGiver(od); applyDefaults(); }
    var por = (qs.get('poruka') || '').toLowerCase();
    var list = msgsFor(za);
    var hit = list.filter(function (x) { return String(x.id).toLowerCase() === por; })[0];
    if (por === 'svoja') st.m = 'OWN';
    else if (hit) { st.m = hit.id; if (list.indexOf(hit) >= VISIBLE) st.more = true; }
    applyDefaults(); renderMsgs(); update();
  } else { renderMsgs(); update(); }


  /* ---------- poslije narudžbe: kartica krupno + 30 min za izmjene ----------
     Na potvrdi kupac vidi tačno karticu koju je naručio (u kutiji i ravno) i
     može je, kao i telefon i adresu, ispraviti dok traje token narudžbe
     (30 min, worker /edit). Izmjena kartice vraća stranicu u izgled prije
     narudžbe (koraci 1–3), a dole stoji traka „Sačuvaj izmjenu". Ako se kupac
     vrati na stranicu u tom roku, iznad konfiguratora stoji ista ponuda.
     Worker odbija izmjenu kad je narudžba štampana, poslana ili otkazana. */
  var EDIT_KEY = 'mc_order_edit';
  var SHOP_PHONE = root.dataset.shopPhone || '051 894 108';
  var ERR = {
    expired: 'Vrijeme za izmjene je isteklo. Ako trebaš nešto promijeniti, nazovi nas: ' + SHOP_PHONE + '.',
    token: 'Izmjena nije moguća s ove stranice. Nazovi nas: ' + SHOP_PHONE + '.',
    locked: 'Narudžba je već u pripremi, pa izmjenu možemo uraditi samo telefonom: ' + SHOP_PHONE + '.',
    phone: 'Provjeri broj telefona, npr. 061 234 567.',
    validation: 'Popuni ime i prezime, adresu i grad.',
    card: 'Kartica mora imati poruku. Izaberi poruku ili napiši svoju.',
    net: 'Nije sačuvano. Provjeri internet i pokušaj ponovo.'
  };

  function snap() {
    return { st: JSON.parse(JSON.stringify(st)), dirty: { head: dirty.head, sign: dirty.sign },
      head: head.value, sign: sign.value, own: own.value, asis: asis.checked };
  }
  function restore(s) {
    if (!s || !s.st || !s.st.r || !$('[data-mc-r="' + s.st.r + '"]', root)) return;
    pickRecipient(s.st.r, true);
    if (hasGiver(s.st.r)) setGiver(s.st.g);
    st.m = s.st.m; st.more = !!s.st.more; st.open = false; st.occ = s.st.occ || '';
    own.value = s.own || ''; var oc = $('[data-mc-own-count]', root); if (oc) oc.textContent = own.value.length;
    asis.checked = !!s.asis;
    dirty.head = !!s.dirty.head; dirty.sign = !!s.dirty.sign;
    head.value = s.head || ''; sign.value = s.sign || '';
    renderMsgs(); update();
  }
  function cardNow() {
    var m = current(), text = m ? m.text : '';
    return { naslov: head.value.trim() || (m && m.title) || (st.r ? fallbackTitle() : ''),
      poruka: text, potpis: sign.value.trim(), povod: st.occ || '' };
  }

  function tokenExp(t) { var e = parseInt(String(t || '').split('.')[0], 10); return e ? e * 1000 : 0; }
  function loadCtx() {
    try {
      var c = JSON.parse(localStorage.getItem(EDIT_KEY) || 'null');
      if (c && c.exp > Date.now() && c.path === location.pathname) return c;
      localStorage.removeItem(EDIT_KEY);
    } catch (e) {}
    return null;
  }
  function saveCtx(c) { try { localStorage.setItem(EDIT_KEY, JSON.stringify(c)); } catch (e) {} }
  function dropCtx() { try { localStorage.removeItem(EDIT_KEY); } catch (e) {} }

  function postEdit(ctx, body) {
    var url = String(ctx.endpoint).replace(/\/+$/, '') + '/edit';
    var payload = { orderId: ctx.orderId, token: ctx.token };
    for (var k in body) payload[k] = body[k];
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok || !j.ok) { var e = new Error(j.error || 'http'); e.code = j.error || 'net'; throw e; }
          return j;
        });
      }, function () { var e = new Error('net'); e.code = 'net'; throw e; });
  }

  function node(tag, cls, txt) { var n = document.createElement(tag); if (cls) n.className = cls; if (txt != null) n.textContent = txt; return n; }
  var savebar = null, editing = null;
  function ensureSavebar() {
    if (savebar) return savebar;
    savebar = node('div', 'mcp-savebar'); savebar.hidden = true;
    var msg = node('p', 'mcp-savebar__msg'); msg.setAttribute('role', 'status'); msg.setAttribute('aria-live', 'polite');
    var row = node('div', 'mcp-savebar__row');
    var cancel = node('button', 'mcp-savebar__no', 'Odustani'); cancel.type = 'button';
    var save = node('button', 'mcp-savebar__yes', 'Sačuvaj izmjenu kartice'); save.type = 'button';
    row.appendChild(cancel); row.appendChild(save);
    savebar.appendChild(msg); savebar.appendChild(row);
    document.body.appendChild(savebar);
    cancel.addEventListener('click', function () { exitCardEdit(false); });
    save.addEventListener('click', function () {
      if (!editing) return;
      var card = cardNow();
      if (!card.poruka) { msg.textContent = ERR.card; return; }
      save.disabled = true; save.textContent = 'Čuvam…'; msg.textContent = '';
      postEdit(editing.ctx, { card: card }).then(function () {
        editing.ctx.card = snap(); saveCtx(editing.ctx);
        var done = editing.onSaved;
        exitCardEdit(true);
        if (done) done();
      }, function (e) {
        msg.textContent = ERR[e.code] || ERR.net;
        if (e.code === 'expired' || e.code === 'locked' || e.code === 'token') setTimeout(function () { exitCardEdit(false); }, 4000);
      }).then(function () { save.disabled = false; save.textContent = 'Sačuvaj izmjenu kartice'; });
    });
    return savebar;
  }

  function enterCardEdit(ctx, panel, onSaved) {
    ensureSavebar();
    editing = { ctx: ctx, panel: panel, onSaved: onSaved, before: snap(), ordered: document.body.hasAttribute('data-bh-ordered') };
    // stranica se vraća u izgled prije narudžbe; potvrda i forma su skriveni dok traje izmjena
    document.body.removeAttribute('data-bh-ordered');
    document.body.setAttribute('data-mc-editing', '');
    savebar.hidden = false;
    $('.mcp-savebar__msg', savebar).textContent = '';
    var top = document.querySelector('.mcp-gal') || root;
    top.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setTimeout(renderCards, 60);
  }
  function exitCardEdit(keep) {
    if (!editing) return;
    var e = editing; editing = null;
    if (!keep) restore(e.before);
    document.body.removeAttribute('data-mc-editing');
    if (e.ordered) document.body.setAttribute('data-bh-ordered', '');
    if (savebar) savebar.hidden = true;
    setTimeout(function () { renderCards(); if (e.panel) e.panel.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
  }

  /* ---------- potvrda po Claude Design prijedlogu „Moments potvrda narudžbe" ----------
     Redoslijed je ono što kupac treba uraditi: šta se desilo, koliko vremena
     ima za ispravke, kartica (s dugmetom za izmjenu odmah ispod), dostava s
     „Ispravi" na istom mjestu, iznos za kurira, šta slijedi. Izmjena kartice
     je panel odozdo s poljima i karticom koja se mijenja dok kupac piše;
     dostava se ispravlja u svom okviru. Postojeća ponuda „dodaj u isti paket",
     upozorenje o duploj narudžbi i „Nastavi kupovinu" ostaju (premještaju se). */

  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  function hhmm(ms) { var d = new Date(ms); return pad2(d.getHours()) + ':' + pad2(d.getMinutes()); }
  function svg(path, color, size, w) {
    return '<svg width="' + (size || 20) + '" height="' + (size || 20) + '" viewBox="0 0 24 24" fill="none" stroke="' + (color || 'currentColor') + '" stroke-width="' + (w || 2.2) + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + path + '</svg>';
  }
  var IC = {
    check: '<path d="M5 12.5l4.5 4.5L19 7.5"></path>',
    clock: '<circle cx="12" cy="12" r="9"></circle><path d="M12 7v5l3 2"></path>',
    pen: '<path d="M4 20h4L19 9l-4-4L4 16v4z"></path><path d="M13.5 6.5l4 4"></path>',
    lock: '<rect x="5" y="11" width="14" height="9" rx="2"></rect><path d="M8 11V8a4 4 0 0 1 8 0v3"></path>',
    phone: '<path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2"></path>',
    x: '<path d="M6 6l12 12M18 6L6 18"></path>'
  };
  function phoneOk(v) { var d = String(v || '').replace(/\D/g, '').replace(/^00/, '').replace(/^387/, '').replace(/^0/, ''); return d.length === 8; }
  function telHref() { return 'tel:' + SHOP_PHONE.replace(/\D/g, ''); }
  function productTitle() { var t = document.querySelector('.mcp-info__title'); return t ? t.textContent.trim() : ''; }
  function productImage() { var m = document.querySelector('meta[property="og:image:secure_url"]') || document.querySelector('meta[property="og:image"]'); return m ? m.content : ''; }

  /* ---------- panel „Izmijeni karticu" ---------- */
  var sheet = null;
  function openSheet(ui) {
    if (sheet) return;
    var before = snap(), m0 = current(), m0id = st.m, m0text = m0 ? m0.text : '';
    var ov = node('div', 'mcp-sheet');
    ov.innerHTML =
      '<div class="mcp-sheet__dim" data-x></div>' +
      '<section class="mcp-sheet__box" role="dialog" aria-modal="true" aria-labelledby="mcp-sheet-h">' +
        '<div class="mcp-sheet__grab"><span></span></div>' +
        '<div class="mcp-sheet__top"><h2 id="mcp-sheet-h">Izmijeni karticu</h2>' +
          '<button type="button" class="mcp-sheet__close" aria-label="Zatvori" data-x>' + svg(IC.x, '#3A342C', 20) + '</button></div>' +
        '<div class="mcp-sheet__body">' +
          '<div class="mc-flat mcp-sheet__card" data-sheet-card></div>' +
          '<p class="mcp-sheet__live">Kartica se mijenja dok pišeš.</p>' +
          '<label class="mcp-sheet__f"><span>Naslov</span><input type="text" maxlength="40" data-f="naslov"></label>' +
          '<label class="mcp-sheet__f"><span class="mcp-sheet__fl"><span>Poruka</span><span class="mcp-sheet__count" data-count></span></span><textarea rows="6" data-f="poruka"></textarea></label>' +
          '<button type="button" class="mcp-sheet__other" data-other>Izaberi drugu gotovu poruku →</button>' +
          '<label class="mcp-sheet__f"><span>Potpis</span><input type="text" maxlength="40" data-f="potpis"></label>' +
          '<div class="mcp-sheet__f" data-occ-wrap><span>Čestitka iznad potpisa</span><div class="mcp-sheet__chips" data-occ></div></div>' +
          '<p class="mcp-sheet__err" role="alert" data-err></p>' +
        '</div>' +
        '<div class="mcp-sheet__foot"><button type="button" class="mcp-sheet__no" data-x>Odustani</button>' +
          '<button type="button" class="mcp-sheet__yes" data-save>Sačuvaj karticu</button></div>' +
      '</section>';
    document.body.appendChild(ov);
    document.documentElement.classList.add('mcp-sheet-open');
    sheet = ov;
    buildFlat($('[data-sheet-card]', ov));

    var fN = $('[data-f="naslov"]', ov), fP = $('[data-f="poruka"]', ov), fS = $('[data-f="potpis"]', ov);
    var c0 = cardNow();
    // gotove poruke znaju biti duže od granice za „svoju" (K-14 ima ~430 znakova)
    var limit = Math.max(parseInt(own.getAttribute('maxlength'), 10) || 400, c0.poruka.length);
    fN.value = c0.naslov; fP.value = c0.poruka; fP.maxLength = limit; fS.value = c0.potpis;
    var count = function () { $('[data-count]', ov).textContent = fP.value.length + '/' + limit; };
    count();

    fN.addEventListener('input', function () { dirty.head = true; head.value = fN.value; update(); });
    fS.addEventListener('input', function () { dirty.sign = true; sign.value = fS.value; renderSignChips(); update(); });
    fP.addEventListener('input', function () {
      count();
      if (fP.value === m0text && m0id !== 'OWN') { st.m = m0id; }
      else { st.m = 'OWN'; own.value = fP.value; asis.checked = true; }
      dirty.head = true; head.value = fN.value;    // naslov ostaje kakav je, i kad poruka postane „svoja"
      update();
    });

    // čestitke: iste kao u konfiguratoru, samo one koje važe za ovog primaoca
    var occBox = $('[data-occ]', ov);
    var opts = [['', 'Bez čestitke']].concat($$('[data-mc-occ]', root).filter(function (b) { return !b.hidden; }).map(function (b) { return [b.dataset.mcOcc, b.dataset.mcOcc]; }));
    var paintOcc = function () {
      occBox.innerHTML = '';
      opts.forEach(function (o) {
        var b = node('button', 'mcp-sheet__chip', o[1]); b.type = 'button';
        b.setAttribute('aria-pressed', String((st.occ || '') === o[0]));
        b.addEventListener('click', function () { st.occ = o[0]; renderOcc(); update(); paintOcc(); });
        occBox.appendChild(b);
      });
    };
    if (opts.length > 1) paintOcc(); else $('[data-occ-wrap]', ov).hidden = true;
    setTimeout(renderCards, 30);

    var close = function (keep) {
      if (!sheet) return;
      if (!keep) restore(before);
      ov.remove(); sheet = null;
      document.documentElement.classList.remove('mcp-sheet-open');
      document.removeEventListener('keydown', esc);
      setTimeout(renderCards, 30);
    };
    var esc = function (e) { if (e.key === 'Escape') close(false); };
    document.addEventListener('keydown', esc);
    $$('[data-x]', ov).forEach(function (b) { b.addEventListener('click', function () { close(false); }); });

    $('[data-other]', ov).addEventListener('click', function () {
      close(false);
      enterCardEdit(ui.ctx, ui.root, function () { ui.saved(); });
    });

    var save = $('[data-save]', ov), err = $('[data-err]', ov);
    save.addEventListener('click', function () {
      var card = cardNow();
      if (!card.poruka) { err.textContent = ERR.card; fP.focus(); return; }
      save.disabled = true; save.textContent = 'Čuvam…'; err.textContent = '';
      postEdit(ui.ctx, { card: card }).then(function () {
        ui.ctx.card = snap(); saveCtx(ui.ctx);
        close(true);
        ui.saved();
      }, function (e) {
        err.textContent = ERR[e.code] || ERR.net;
        save.disabled = false; save.textContent = 'Sačuvaj karticu';
        if (e.code === 'expired' || e.code === 'locked' || e.code === 'token') setTimeout(function () { close(false); ui.expire(); }, 3500);
      });
    });
    setTimeout(function () { fN.focus({ preventScroll: true }); }, 50);
    ui.closeSheet = function () { close(false); };
  }

  /* ---------- blokovi potvrde ---------- */
  function buildConfirm(ctx, opts) {
    var editable = root.dataset.mcEdit === 'true' && ctx.token && ctx.endpoint && ctx.exp > Date.now();
    var wrap = node('div', 'mcpc' + (opts.banner ? ' mcpc--banner' : ''));
    var ui = { ctx: ctx, root: wrap };

    // zaglavlje
    var hd = node('section', 'mcpc__head');
    hd.innerHTML = '<span class="mcpc__tick">' + svg(IC.check, '#1F3B2C', 22, 2.6) + '</span><div><h2 class="mcpc__h">Narudžba je primljena</h2>' +
      '<p class="mcpc__sub">Broj <b></b> · plaćaš kuriru kad paket stigne.</p></div>';
    $('b', hd).textContent = ctx.orderNumber || '';
    wrap.appendChild(hd);
    if (opts.dupe) wrap.appendChild(opts.dupe);

    // sat
    var timer = node('div', 'mcpc__timer');
    wrap.appendChild(timer);

    // kartica
    var cardBox = node('section', 'mcpc__card');
    if (!opts.banner) {
      cardBox.innerHTML = '<p class="mcpc__eyebrow">Tvoja kartica</p><p class="mcpc__note">Ovako je štampamo i stavljamo u kutiju ispod lančića.</p>' +
        '<span class="mcpc__badge" data-badge hidden></span><div class="mc-flat mcpc__flat" data-flat></div>' +
        '<div class="mcpc__prod"><img alt="" width="60" height="60" loading="lazy"><div><b></b><span>925 srebro · poklon kutija i kesa</span></div></div>';
      var img = $('.mcpc__prod img', cardBox), src = productImage();
      if (src) { img.src = src; img.alt = productTitle(); } else img.remove();
      $('.mcpc__prod b', cardBox).textContent = productTitle();
      buildFlat($('[data-flat]', cardBox));
    } else {
      cardBox.innerHTML = '<span class="mcpc__badge" data-badge hidden></span>';
    }
    var cta = node('div', 'mcpc__cta');
    cta.innerHTML = '<button type="button" class="mcpc__btn" data-edit>' + svg(IC.pen, '#FFFFFF', 18) + '<span>Izmijeni tekst kartice</span></button>' +
      '<p class="mcpc__help">Pogrešno ime ili slovo? Ispravi sada — kartice štampamo jednom dnevno.</p>' +
      '<p class="mcpc__ok" role="status" data-ok></p>';
    cardBox.appendChild(cta);
    wrap.appendChild(cardBox);

    // dostava
    var c = ctx.contact || {};
    var del = node('section', 'mcpc__box mcpc__del');
    var paintDel = function () {
      var cc = ctx.contact || {};
      del.innerHTML = '<div class="mcpc__boxh"><h3>Dostava</h3><span class="mcpc__pill" data-delbadge hidden>Ispravljeno</span>' +
        '<button type="button" class="mcpc__fix" data-fix>Ispravi</button></div>' +
        '<p class="mcpc__lines"><b></b><span data-l="phone"></span><span data-l="addr"></span></p>' +
        '<p class="mcpc__small">Kurir te zove na ovaj broj prije dostave.</p>';
      $('.mcpc__lines b', del).textContent = cc.name || '';
      $('[data-l="phone"]', del).textContent = cc.phone || '';
      $('[data-l="addr"]', del).textContent = (cc.address || '') + ', ' + (cc.zip ? cc.zip + ' ' : '') + (cc.city || '');
      $('[data-delbadge]', del).hidden = !ui.delFixed;
      var fx = $('[data-fix]', del);
      if (!ui.editable) fx.hidden = true;
      fx.addEventListener('click', editDel);
    };
    var editDel = function () {
      var cc = ctx.contact || {};
      del.classList.add('is-edit');
      del.innerHTML = '<div class="mcpc__boxh"><h3>Ispravi dostavu</h3></div><p class="mcpc__small">Promijeni samo ono što je pogrešno.</p>' +
        '<form class="mcpc__form" novalidate>' +
        '<label class="mcpc__f"><span>Ime i prezime</span><input name="name" autocomplete="name"></label>' +
        '<label class="mcpc__f"><span>Telefon</span><input name="phone" type="tel" inputmode="tel" autocomplete="tel"><em class="mcpc__ferr" data-perr></em></label>' +
        '<label class="mcpc__f"><span>Adresa</span><input name="address" autocomplete="street-address"></label>' +
        '<div class="mcpc__two"><label class="mcpc__f"><span>Grad</span><input name="city" autocomplete="address-level2"></label>' +
        '<label class="mcpc__f"><span>Poštanski br.</span><input name="zip" inputmode="numeric" autocomplete="postal-code"></label></div>' +
        '<p class="mcpc__ferr" role="alert" data-gerr></p>' +
        '<div class="mcpc__acts"><button type="button" class="mcpc__ghost" data-cancel>Odustani</button><button type="submit" class="mcpc__btn">Sačuvaj dostavu</button></div>' +
        '</form>';
      var f = $('form', del);
      ['name', 'phone', 'address', 'city', 'zip'].forEach(function (k) { f.elements[k].value = cc[k] || ''; });
      $('[data-cancel]', del).addEventListener('click', function () { del.classList.remove('is-edit'); paintDel(); });
      f.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var v = function (n) { return f.elements[n].value.trim(); };
        var contact = { name: v('name'), phone: v('phone'), address: v('address'), city: v('city'), zip: v('zip') };
        var perr = $('[data-perr]', del), gerr = $('[data-gerr]', del);
        perr.textContent = ''; gerr.textContent = '';
        f.elements.phone.classList.remove('is-bad');
        if (!phoneOk(contact.phone)) { perr.textContent = 'Provjeri broj, npr. 061 234 567.'; f.elements.phone.classList.add('is-bad'); f.elements.phone.focus(); return; }
        if (contact.name.length < 3 || contact.address.length < 4 || contact.city.length < 2) { gerr.textContent = ERR.validation; return; }
        var btn = $('button[type="submit"]', del); btn.disabled = true; btn.textContent = 'Čuvam…';
        postEdit(ctx, { contact: contact }).then(function () {
          ctx.contact = contact; saveCtx(ctx); ui.delFixed = true;
          var ad = document.querySelector('[data-bh-recap="address"]'); if (ad) ad.textContent = contact.address + ', ' + contact.city;
          $$('[data-bh-phone]').forEach(function (n) { n.textContent = contact.phone; });
          del.classList.remove('is-edit'); paintDel();
        }, function (e) {
          btn.disabled = false; btn.textContent = 'Sačuvaj dostavu';
          if (e.code === 'phone') { perr.textContent = ERR.phone; f.elements.phone.classList.add('is-bad'); }
          else gerr.textContent = ERR[e.code] || ERR.net;
          if (e.code === 'expired' || e.code === 'locked' || e.code === 'token') setTimeout(ui.expire, 3500);
        });
      });
      f.elements.name.focus({ preventScroll: true });
    };
    if (c.name || c.address) wrap.appendChild(del);

    // iznos
    if (!opts.banner) {
      var pay = node('section', 'mcpc__pay');
      pay.innerHTML = '<div><b>Plaćaš kuriru</b><span data-paysub>s dostavom</span></div><strong data-total></strong>';
      var src2 = document.querySelector('[data-bh-recap="total"]');
      var syncTotal = function () {
        $('[data-total]', pay).textContent = src2 ? src2.textContent.trim() : '';
        var adds = $$('[data-bh-recap="product"] .bh-recap__add').map(function (n) { return n.textContent.replace(/^\+\s*/, ''); });
        $('[data-paysub]', pay).textContent = adds.length ? 'uz dodano: ' + adds.join(', ') + ' · s dostavom' : 's dostavom';
      };
      syncTotal();
      if (src2 && window.MutationObserver) {
        var mo = new MutationObserver(syncTotal);
        mo.observe(src2, { childList: true, characterData: true, subtree: true });
        var pc = document.querySelector('[data-bh-recap="product"]'); if (pc) mo.observe(pc, { childList: true, subtree: true });
      }
      var row = node('div', 'mcpc__row'); row.appendChild(del); row.appendChild(pay);
      wrap.appendChild(row);

      // šta slijedi
      var next = node('section', 'mcpc__next');
      next.innerHTML = '<h3>Šta slijedi</h3><ol>' +
        '<li class="is-now"><span><b>Sada</b> · <span data-step1>provjeriš karticu i adresu.</span></span></li>' +
        '<li><span><b>Pakovanje</b> · štampamo karticu, pakujemo lančić u kutiju i kesu.</span></li>' +
        '<li><span><b>1–3 radna dana</b> · kurir donosi paket, plaćaš pri preuzimanju.</span></li></ol>';
      wrap.appendChild(next);
      ui.step1 = $('[data-step1]', next);
    }

    ui.editable = editable;
    ui.saved = function () {
      var b = $('[data-badge]', wrap); b.textContent = 'Izmijenjeno u ' + hhmm(Date.now()); b.hidden = false;
      var ok = $('[data-ok]', wrap); ok.innerHTML = svg(IC.check, '#1F3B2C', 18, 2.6) + '<span>Kartica je sačuvana. Štampamo ovu verziju.</span>';
      setTimeout(renderCards, 30);
    };
    ui.expire = function () {
      ui.editable = false;
      if (ui.closeSheet) ui.closeSheet();
      if (editing) exitCardEdit(false);
      dropCtx();
      timer.className = 'mcpc__locked';
      timer.innerHTML = '<p>' + svg(IC.lock, '#3A342C', 20) + '<span><b>Kartica je poslana u pripremu.</b> Ako ipak trebaš izmjenu, javi nam se što prije.</span></p>' +
        '<a class="mcpc__call" href="' + telHref() + '">' + svg(IC.phone) + '<span>Pozovi ' + SHOP_PHONE + '</span></a>';
      cta.querySelector('[data-edit]').hidden = true;
      cta.querySelector('.mcpc__help').hidden = true;
      var fx = $('[data-fix]', wrap); if (fx) fx.hidden = true;
      if (del.classList.contains('is-edit')) { del.classList.remove('is-edit'); paintDel(); }
      if (ui.step1) ui.step1.textContent = 'kartica i adresa su poslane u pripremu.';
      if (opts.banner) setTimeout(function () { wrap.remove(); }, 10000);
    };

    if (c.name || c.address) paintDel();
    $('[data-edit]', cta).addEventListener('click', function () {
      if (opts.banner) restore(ctx.card);
      openSheet(ui);
    });

    if (editable) {
      var until = hhmm(ctx.exp);
      if (ui.step1) ui.step1.textContent = 'provjeriš karticu i adresu. Ispravke primamo do ' + until + '.';
      var tick = function () {
        var left = ctx.exp - Date.now();
        if (left <= 0) { clearInterval(iv); ui.expire(); return; }
        var s = Math.floor(left / 1000);
        timer.innerHTML = svg(IC.clock, '#7A5418', 20) + '<span>Još <span class="mcpc__mm">' + pad2(Math.floor(s / 60)) + ':' + pad2(s % 60) + '</span> možeš ispraviti karticu i adresu</span>';
      };
      var iv = setInterval(tick, 1000); tick();
    } else {
      timer.remove();
      $('[data-edit]', cta).hidden = true; $('.mcpc__help', cta).hidden = true;
    }

    if (!opts.banner) {
      var foot = node('a', 'mcpc__call mcpc__call--foot');
      foot.href = telHref();
      foot.innerHTML = svg(IC.phone) + '<span>Pitanje? Pozovi ' + SHOP_PHONE + '</span>';
      ui.foot = foot;
    }
    return ui;
  }

  document.addEventListener('bh:ordered', function (e) {
    var d = e.detail || {}, data = d.data || {}, p = d.payload || {};
    var ctx = {
      orderId: data.orderId || '', token: data.token || '', exp: tokenExp(data.token),
      orderNumber: data.orderNumber || '', endpoint: d.endpoint || '', path: location.pathname,
      card: snap(), contact: { name: p.name || '', phone: p.phone || '', address: p.address || '', city: p.city || '', zip: p.zip || '' }
    };
    if (root.dataset.mcEdit === 'true' && ctx.token && ctx.exp > Date.now()) saveCtx(ctx);
    var conf = document.querySelector('[data-bh-pane="done"] .bh-confirm');
    if (!conf || $('.mcpc', conf)) return;
    conf.classList.add('mcp-confirmed');
    var ui = buildConfirm(ctx, { dupe: $('[data-bh-dupe]', conf) });
    conf.insertBefore(ui.root, conf.firstChild);
    var keep = $('.bh-confirm > .bh-btn', conf.parentNode) || $('a.bh-btn', conf);
    if (ui.foot) { if (keep && keep.parentNode === conf) conf.insertBefore(ui.foot, keep); else conf.appendChild(ui.foot); }
    setTimeout(renderCards, 30);
    var top = conf.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  });

  // povratak na stranicu u roku od 30 min: zaglavlje, sat, izmjena kartice i dostave iznad konfiguratora
  (function () {
    var ctx = root.dataset.mcEdit === 'true' && loadCtx();
    if (!ctx) return;
    var ui = buildConfirm(ctx, { banner: true });
    root.parentNode.insertBefore(ui.root, root);
  })();

  /* Javi stanje formi još jednom kad je i ona spremna. Ova skripta je u
     sekciji konfiguratora, IZNAD forme, pa se izvrši prije bh-cod-form.js i
     prvi mc:dedication niko ne čuje. Forma tada stanje čita iz DOM-a, a tamo
     nema „ready", pa bi narudžbu bez izabrane poruke pustila do polja za
     adresu umjesto da kupca vrati na izbor poruke. */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else setTimeout(update, 0);

  // fontovi mijenjaju širinu teksta — ponovo izmjeri kad se učitaju
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(renderCards);
})();
